import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  AccordionBody,
  Accordion,
  AccordionHeader,
  Typography,
} from '@one-thd/sui-atomic-components';
import { SbotdMessaging } from './messaging/SbotdMessaging';
import { SbotwProMessaging } from './messaging/SbotwProMessaging';

export const SeoMessaging = ({ specialBuyType }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const isSBOTD = specialBuyType === 'sbotd';
  const isPro = specialBuyType === 'pro';
  const title = isPro ? 'Special Buys For Pros' : 'Save With The Deal of the Day';

  return (
    <div data-component="SeoMessaging">
      {isMobile ? (
        <Accordion>
          <AccordionHeader variant="body-sm">
            {title}
          </AccordionHeader>
          <AccordionBody>
            {isSBOTD && <SbotdMessaging />}
            {isPro && <SbotwProMessaging />}
          </AccordionBody>
        </Accordion>
      ) : (
        <div className="sui-bg-primary sui-p-4 sui-pb-0">
          <div className="sui-pb-4 sui-text-brand sui-underline">
            <div className="">
              <Typography>
                {title}
              </Typography>
            </div>
          </div>
          {isSBOTD && <SbotdMessaging />}
          {isPro && <SbotwProMessaging />}
        </div>
      )}
    </div>
  );
};

SeoMessaging.propTypes = {
  specialBuyType: PropTypes.oneOf(['sbotd', 'pro']).isRequired
};
